import { render, staticRenderFns } from "./MetaIntegrationButton.vue?vue&type=template&id=44872ce2"
import script from "./MetaIntegrationButton.vue?vue&type=script&lang=js"
export * from "./MetaIntegrationButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports